/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast.
*/
(function() {
  // A11y: pause/play control for autoplaying background videos (WCAG 2.2.2).
  // The theme injects the <video> from a <template> after load, so look it up on click.
  document.addEventListener('click', function(event) {
    var toggle = event.target.closest('[data-video-pause-toggle]');
    if (!toggle) return;

    var scope = toggle.parentElement;
    var videos = scope ? scope.querySelectorAll('video') : [];
    if (!videos.length) return;

    var pausing = toggle.getAttribute('aria-pressed') !== 'true';
    videos.forEach(function(video) {
      if (pausing) {
        video.pause();
      } else {
        var playing = video.play();
        if (playing && playing.catch) playing.catch(function() {});
      }
    });

    toggle.setAttribute('aria-pressed', pausing ? 'true' : 'false');
  });

  // A11y: Broadcast sets aria-haspopup/aria-expanded/aria-controls on the menu item <div>,
  // which isn't allowed on a div. Move them onto the item's top-level link and keep it in sync.
  var NAV_ATTRS = ['aria-haspopup', 'aria-expanded', 'aria-controls'];
  function moveNavAria(item) {
    var link = item.querySelector(':scope > [data-top-link]');
    if (!link) return;
    NAV_ATTRS.forEach(function(attr) {
      if (item.hasAttribute(attr)) {
        link.setAttribute(attr, item.getAttribute(attr));
        item.removeAttribute(attr);
      }
    });
  }
  function initNavAria() {
    document.querySelectorAll('[data-hover-disclosure-toggle]').forEach(function(item) {
      moveNavAria(item);
      new MutationObserver(function() { moveNavAria(item); })
        .observe(item, { attributes: true, attributeFilter: NAV_ATTRS });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initNavAria);
  } else {
    initNavAria();
  }

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
